import { useMemo } from 'react';

import { useOrgs, useSuperAdminSwitchToOrg } from '@/Client/State';
import { LabeledSelect } from '@/Client/Widgets';
import { useAllOrgs } from '@kaiizen/kai-pro-api-react-state';

/** Super admin switch into any org they are not a member of (members switch from the Account page). */
export const SuperAdminOrgSwitcher = () => {
  const { orgs } = useOrgs();
  const { allOrgs } = useAllOrgs();
  const switchToOrg = useSuperAdminSwitchToOrg();

  const filteredAllOrgs = useMemo(
    () => allOrgs.filter(org => !orgs.some(o => o.id === org.id)),
    [allOrgs, orgs],
  );

  const items = useMemo(
    () =>
      filteredAllOrgs.map(org => ({ value: org.id, label: org.name }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [filteredAllOrgs],
  );

  if (!filteredAllOrgs.length) return null;

  return (
    <LabeledSelect
      label='Switch to any organization'
      value=''
      placeholder='Select org to switch to...'
      items={items}
      onChange={switchToOrg}
      emptyMessage='No other organizations'
    />
  );
};
